import { render } from "./DownloadList.vue?vue&type=template&id=4c58227b&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"

import "./DownloadList.vue?vue&type=style&index=0&id=4c58227b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c58227b"]])

export default __exports__